import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const TourContext = createContext({ active: false, startTour: () => {}, stopTour: () => {} });

export const TourProvider = ({ children }) => {
  const [active, setActive] = useState(false);
  const startTour = useCallback(() => setActive(true), []);
  const stopTour = useCallback(() => setActive(false), []);
  const value = useMemo(() => ({ active, startTour, stopTour }), [active, startTour, stopTour]);
  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
};

export const useTour = () => useContext(TourContext);
